/** True when the template row was created very recently and not meaningfully edited yet (created ≈ updated, within 24h). */
export const checkTemplateJustCreated = (createdAt?: string, updatedAt?: string): boolean => {
  if (!createdAt) return false;
  const created = new Date(createdAt).getTime();
  const updated = updatedAt ? new Date(updatedAt).getTime() : created;
  const oneDayMs = 24 * 60 * 60 * 1000;
  return Math.abs(updated - created) < 1000 && Date.now() - created < oneDayMs;
};
